import { jsx } from "react/jsx-runtime";
import { EndBottomSlotBox, EndTopSlotBox, StartBottomSlotBox, StartTopSlotBox } from "../Avatar.styled";
import { useAvatarContext } from "../context/AvatarContext";
const slotMap = {
  "top-left": StartTopSlotBox,
  "top-right": EndTopSlotBox,
  "bottom-left": StartBottomSlotBox,
  "bottom-right": EndBottomSlotBox
};
const SlotBox = (props) => {
  const {
    children,
    position,
    ...rest
  } = props;
  const { size, theme } = useAvatarContext();
  const slotTokens = theme?.avatarV2.slot;
  const slotOffset = size && slotTokens?.offset[size];
  const slotSize = size && slotTokens?.size[size];
  const BoxComponent = slotMap[position];
  if (!BoxComponent)
    return null;
  return /* @__PURE__ */ jsx(BoxComponent, { slotOffset, slotSize, ...rest, children });
};
export {
  SlotBox
};
